export const POST_METHOD_NAME: string = 'POST';
export const CORS_MODE_NAME = 'cors';
export const GET_METHOD_NAME: string = 'GET';
